import { withContext } from 'components/withContext';
import { createContext } from 'react';

const ActiveContext = createContext();
const ActiveConsumer = withContext(ActiveContext, 'active');

export { ActiveContext, ActiveConsumer };
